import React, { useState } from 'react'
import { Card, CardContent } from '../../ui/card'
import { Button } from '../../ui/button'
import { Label } from '../../ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select'
import { EventCombobox } from '../../ui/event-combobox'
import { Loader2 } from 'lucide-react'
import { toast } from 'sonner'
import { extractErrorMessage } from '@/common/extractErrorMessage'
import { useApplicationStore } from '../../../stores/useApplicationStore'
import ReportEndpoints from '../../../endpoints/ReportEndpoints'
import { ReportViewer, useReportViewer } from '../ReportViewer'
import { RoleSelect } from '../RoleSelect'
import { useReportEvent } from '../useReportEvent'
import { rootUrl } from '../reportShared'

export const IdentityByEventPage: React.FC = () => {
  const { events } = useApplicationStore()
  const { viewerProps, openReport, generating, setGenerating } = useReportViewer()
  const { selectedEventId, eventRoles, loadingRoles, selectEvent } = useReportEvent()

  const [roles, setRoles] = useState<number[]>([])
  const [sort, setSort] = useState<string>('lastName')

  const generate = async () => {
    if (!selectedEventId || roles.length === 0) { toast.error('Select an event and at least one role'); return }
    setGenerating(true)
    try {
      const res = await ReportEndpoints.getIdentityExportByEventReport({
        eventId: parseInt(selectedEventId), roles, sort: sort as any, rootUrl,
      })
      openReport('Identity Export by Event', res)
    } catch (error) { toast.error(extractErrorMessage(error, 'Failed to generate report')) }
    finally { setGenerating(false) }
  }

  return (
    <>
      <Card className="max-w-3xl">
        <CardContent className="pt-6 space-y-4">
          <div className="space-y-2">
            <Label>Event *</Label>
            <EventCombobox events={events} value={selectedEventId} onChange={selectEvent} />
          </div>
          {selectedEventId && (
            <>
              <div className="space-y-2">
                <Label>Roles *</Label>
                {loadingRoles ? <Loader2 className="h-4 w-4 animate-spin" /> : <RoleSelect roles={eventRoles} selected={roles} onChange={setRoles} />}
              </div>
              <div className="space-y-2">
                <Label>Sort By</Label>
                <Select value={sort} onValueChange={setSort}>
                  <SelectTrigger className="w-[200px]"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="lastName">Last Name</SelectItem>
                    <SelectItem value="dateModified">Date Modified</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </>
          )}
          <Button onClick={generate} disabled={generating || !selectedEventId}>
            {generating ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Generating...</> : 'Generate Report'}
          </Button>
        </CardContent>
      </Card>
      <ReportViewer {...viewerProps} />
    </>
  )
}
